// extracted by mini-css-extract-plugin
module.exports = {"base":"NavigationBurger_base__3xGmg","base_theme_dark":"NavigationBurger_base_theme_dark__3ikTq","baseThemeDark":"NavigationBurger_base_theme_dark__3ikTq","base_theme_light":"NavigationBurger_base_theme_light__3GUZF","baseThemeLight":"NavigationBurger_base_theme_light__3GUZF","iconHolder":"NavigationBurger_iconHolder__Ic4rw"};
    if(module.hot) {
      // 1586964020386
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  